var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'skeleton '+_vm.classes,style:('width:'+_vm._width+'!important;height:'+_vm._height+'!important;border-radius:'+_vm._corner+';background:'+_vm._background+';')})}
var staticRenderFns = []

export { render, staticRenderFns }